import React from 'react';
import { Button, Text } from '@dotcom/crown-ui';
import classNames from 'classnames';
import { ButtonGroup } from '../../../button-group/button-group';
import { ColorOptionProps } from '../font-drawer-types';
import styles from '../font-drawer.module.scss';

export const ColorOption = ({
  addClass = '',
  colors,
  selectedColor,
  label,
  testId = 'color-option',
  buttonGroupClick,
}: ColorOptionProps): React.ReactElement => {
  const classes = classNames(styles['color-option'], addClass);

  return (
    <div className={classes} data-testid={testId}>
      <Text as="label" className={styles['label']}>
        {label}
      </Text>
      <ButtonGroup
        ariaLabel="Text Color"
        addClass={styles['button-group']}
        defaultClickedIndex={colors.indexOf(selectedColor)}
      >
        {colors.map((colorName, index) => (
          <Button
            onClick={() => buttonGroupClick(colorName)}
            size="icon"
            aria-label={colorName}
            color={colorName}
            className={classNames(styles[`color-${colorName}`], styles.buttons)}
            data-testid={`color-button-${colorName}`}
            key={index}
          >
            <Text as="span" styleVariant="screen-reader">
              {colorName}
            </Text>
          </Button>
        ))}
      </ButtonGroup>
    </div>
  );
};
